import React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { useRootAppStore } from "@hooks";
import { Button } from "@components/buttons";
import { useFixBody } from "@state/hooks/shared";

export default observer(function BetBuilderPopup() {
	const rootStore = useRootAppStore();
	useFixBody(rootStore.betBuilderPopupStore.isActive);
	const { t } = useTranslation();

	return (
		<div className="popup">
			<div className="popup__card popup__card--sml">
				<div className="popup__header">
					<div>Bet Builder</div>
				</div>
				<div className="popup__body">
					<i className="u-icon u-icon--huge u-icon--alert-circle u-mar--x--auto"></i>
					<div className="u-mar--top--xsml">
						{rootStore.betBuilderPopupStore.betBuilderInfoText}
					</div>
				</div>
				<div className="popup__footer">
					<Button
						className="btn--base btn--block btn--primary--inverted"
						onClick={() => {
							rootStore.betBuilderPopupStore.deactivateBetBuilderPopup();
						}}
						btnText={t("COMMON.CANCEL")}
					/>
					{rootStore.betBuilderPopupStore
						.betBuilderRoutingCallback && (
						<Button
							className="btn--base btn--block btn--danger"
							onClick={() => {
								rootStore.betBuilderPopupStore.betBuilderRoutingCallback?.();
							}}
							btnText={t("COMMON.YES")}
						/>
					)}
				</div>
			</div>
		</div>
	);
});
